<template>
  <div class="container">
    <page-header title="Заказы" />

    <Table
      table-id="PageOrdersTable"
      :table-config="tableConfig"
      :table-data="orders"
      :current-page="page"
      :pages="totalPages"
      @btn-click="btnClickHandler"
      @request="onRequestData"
    />

    <q-dialog
      content-class="order-details-dialog"
      :value="!!selectedOrder"
      @hide="onDialogHide"
    >
      <div class="order-details-dialog__content-wrapper">
        <q-btn
          v-close-popup
          class="order-details-dialog__close-btn"
          icon="close"
          flat
          round
          dense
        />

        <order-details class="order-details-dialog__content" :order="selectedOrder" />
      </div>
    </q-dialog>
  </div>
</template>

<script>
/**
 * Страница заказов
 * @module PageOrders/Component/App
 * @requires PageOrders/Store
 * @requires Shared/Component/PageHeader
 * @requires npm:vuex
 * @requires Shared/Component/Table
 * @requires PageOrders/Component/OrderDetails
 * @requires PageOrders/ordersTableConfig
 *
 * @vue-data {Array.<Object>} tableConfig
 * @vue-data {Object} selectedOrder
 */
import store from 'PageOrders/store'
import PageHeader from 'Shared/PageHeader'
import { mapState, mapActions } from 'vuex'
import Table from 'Shared/Table'
import OrderDetails from 'PageOrders/components/OrderDetails'
import tableConfig from 'PageOrders/ordersTableConfig'

export default {
  name: 'PageOrders',
  store,
  components: {
    PageHeader,
    Table,
    OrderDetails
  },
  data: () => ({
    tableConfig,
    selectedOrder: null
  }),
  computed: {
    ...mapState(['orders', 'page', 'totalPages'])
  },
  /**
   * Запросо списка заказов
   * */
  async created() {
    await this.getOrders()
  },
  methods: {
    ...mapActions(['getOrders']),

    /**
     * Обработчик на клик по кнопке в таблице
     * Устанавливает заказ в качестве выбранного для отображения карточки заказа
     * */
    btnClickHandler({ row }) {
      this.selectedOrder = row
    },

    /**
     * Обработчик на запрос новых данных
     * */
    onRequestData() {
      console.log('onRequestData')
    },

    /**
     * Обработчик на закрытие модалки деталей заказа
     * Обнуляет выбранный заказ
     * */
    onDialogHide() {
      this.selectedOrder = null
    }
  }
}
</script>

<style lang="scss">
.order-details-dialog__content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 80vw !important;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.order-details-dialog__content {
  flex-grow: 1;
}

.order-details-dialog__close-btn {
  position: absolute !important;
  top: 10px;
  right: 10px;
  z-index: 1;
}
</style>
